<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card-main row fit">
            <div
              v-for="(obj, index) in computedData"
              :key="index"
              :class="
                obj.columnsSize
                  ? 'col-' + obj.columnsSize
                  : !obj.columnsPerLine
                  ? 'col-12'
                  : 'col-md-' + 12 / obj.columnsPerLine
              "

            >
              <label>{{ obj.label }}:</label>
              {{ obj.value }}
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'landfillDetailPage',
  components: {},
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class LandfillDetailPage extends Vue {
  get computedData () {
    this.elements[0].inputs.forEach((input) => {
      input.value = this.__formatFilterChipValue(
        input,
        this.elements[0].dadosForm
      )
      this.label(input, this.elements[0].dadosForm)
    })
    return this.elements[0].inputs
  }

  label (elem, params) {
    try {
      if (elem.label && elem.label[0] === '$') {
        const key = elem.label.substring(2, elem.label.length - 1)
        elem.label = params[key] ?? elem.label
      }
    } catch (error) {}
  }

  __formatFilterChipValue (filtered, model) {
    switch (filtered.type.toLowerCase()) {
      case 'select':
      case 'select_ajax':
        return this.__getTypeSelectValueLabel(
          filtered.model,
          model[filtered.model]
        )
      case 'date':
        return this.__getFormatedData(filtered, model)
      case 'date_range':
        return this.__getFormatedDataRange(filtered, model)
      default:
        return model[filtered.model]
    }
  }

  __getTypeSelectValueLabel (key, value) {
    const el = this.elements[0].relacionamentos[key].find(
      rel => rel.value === value
    )
    return el ? el.label : value
  }

  __getFormatedData (filtered, model) {
    return this.date.formatDate(model[filtered.model], filtered.format)
  }

  __getFormatedDataRange (filtered, model) {
    const format = filtered.format.toUpperCase()
    return `${model[filtered.model].inicial} - ${model[filtered.model].final} `
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.data-card-main.q-card__section >
  div:nth-child(1),
  div:nth-child(2),
  div:nth-child(5),
  div:nth-child(6),
  div:nth-child(9),
  div:nth-child(10),
  div:nth-child(13),
  div:nth-child(14),
  div:nth-child(18),
  div:nth-child(19),
  div:nth-child(22),
  div:nth-child(23),{
  background-color: $ice;
}
</style>
